export interface IProfileData {
  subscriberid: string;
  fullName: string;
  subscriber_Package: string;
  subscriber_Package_Display: string;
  subscriber_Package_Type: string;
  email: string;
  phone: string;
  first_Bill_Date: string;
  billing_Date: string;
  blocked: string;
  registered: string;
  priviledges: ProfilePrivileges;
  happy_Day: null;
}

export enum PROFILE_ACTIONS {
  USAGE = 'usage',
  EXTRA_GB = 'extra_GB',
  PURCHASE_HISTORY = 'purchase_History',
  PROFILE = 'profile',
  PROTOCOL_REPORT = 'protocol_Report',
  PURCHASE_PROTOCOL_REPORT = 'purchase_Protocol_Report',
  PROMO_CODE = 'promo_Code',
  DATA_GIFTING = 'data_Gifting',
  DATA_TRANSFER = 'data_Transfer',
  DATA_ADDONS = 'data_AddOns',
  FREE_DATA = 'free_Data',
  BONUS_DATA = 'bonus_Data',
  HAPPY_DAY = 'happy_Day',
  MY_PLAN = 'my_Plan',
}

export interface ProfilePrivileges {
  [PROFILE_ACTIONS.USAGE]: string;
  [PROFILE_ACTIONS.EXTRA_GB]: string;
  [PROFILE_ACTIONS.PURCHASE_HISTORY]: string;
  [PROFILE_ACTIONS.PROFILE]: string;
  [PROFILE_ACTIONS.PROTOCOL_REPORT]: string;
  [PROFILE_ACTIONS.PURCHASE_PROTOCOL_REPORT]: string;
  [PROFILE_ACTIONS.PROMO_CODE]: string;
  [PROFILE_ACTIONS.DATA_GIFTING]: string;
  [PROFILE_ACTIONS.DATA_TRANSFER]: string;
  [PROFILE_ACTIONS.DATA_ADDONS]: string;
  [PROFILE_ACTIONS.FREE_DATA]: string;
  [PROFILE_ACTIONS.BONUS_DATA]: string;
  [PROFILE_ACTIONS.HAPPY_DAY]: string;
  [PROFILE_ACTIONS.MY_PLAN]: string;
}
